module.exports = __webpack_public_path__ + "static/media/hero23.0b05ed40.jpg";